export default "__VITE_ASSET__CGMNRwOP__ 100w";